import React from 'react'
import { Element, Form } from 'react-bulma-components'
import { Mission } from '../../../api/missions'
import { WorkPeriod } from '../../../api/work-periods'
import { useAbandonMutation, useUpdateMutation } from '../../../queries/work-periods'
import Avatar from '../../avatar/avatar'
import ConfirmationModal, {
  ConfirmationModalBaseProps,
} from '../../confirmation-modal/confirmation-modal'
import Protected from '../../protected/protected'

interface AbandonConfirmationProps extends ConfirmationModalBaseProps {
  mission: Mission
  workPeriod: WorkPeriod
}

const AbandonConfirmation: React.FC<AbandonConfirmationProps> = ({
  show,
  hide,
  mission,
  workPeriod,
}) => {
  const abandonWorkPeriodMutation = useAbandonMutation()
  const [replaceWorkersRequestPost, setReplaceWorkersRequestPost] = React.useState(false)

  const onConfirm = () => {
    abandonWorkPeriodMutation.mutate({
      missionId: mission._id,
      workPeriodId: workPeriod._id,
      isAbandoned: true,
      isReplaceable: replaceWorkersRequestPost,
    })
    hide()
  }

  const canBeReplaced = mission.workPeriods.some(w => w.__actions.canBeReplaced)

  return (
    <ConfirmationModal onConfirm={onConfirm} show={show} onCancel={hide}>
      <Element>
        Êtes vous certain de vouloir abandonner la mission de&nbsp;
        <strong>
          <Avatar user={mission.user} />
        </strong>
        ? <br />
      </Element>
      {canBeReplaced && (
        <Protected roles={['employerMember']}>
          <Element mt={3}>
            <Element renderAs="hr" />
            <Element renderAs="ul">
              <Element renderAs="li">
                Vous pouvez demander à l'Agence <b> {mission.interimAgency?.name}</b> un remplaçant.
              </Element>
            </Element>
            <Form.Checkbox
              mt={3}
              checked={replaceWorkersRequestPost}
              onChange={() => setReplaceWorkersRequestPost(!replaceWorkersRequestPost)}
              data-test="cancel-and-ask-for-a-replacement"
            >
              Demander un remplaçant
            </Form.Checkbox>
          </Element>
        </Protected>
      )}
    </ConfirmationModal>
  )
}

export default AbandonConfirmation
